<ng-container *ngIf="dashboardState$ | async as dashboardState">
  <ng-container *ngIf="dashboardState.report.errorMessage?.error?.status">
    <div class="no-chart-data d-flex h-100 mb-3 mt-3 justify-content-center align-items-center" data-category="figures">
      <div>
        <figure class="figure">
          <ng-container *ngIf="tile; else BigKaliuk">
            <svg class="kaliuk kaliuk-middle">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
          </ng-container>
          <ng-template #BigKaliuk>
            <svg class="kaliuk kaliuk-big">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
          </ng-template>
          <figcaption class="figure-caption">
            <h4>
              {{ pageSomethingwentwrongHeadingString + ' (' + dashboardState.report.errorMessage?.error?.status + ')' }}
            </h4>
          </figcaption>
        </figure>
      </div>
    </div>
  </ng-container>

  <!--<div *ngIf="dashboardState.report.errorMessage" class="request-error">-->
  <!--{{ 'dashboardRequestError' | translate }}-->
  <!--</div>-->

  <ng-container *ngIf="chartData$ | async as chartData; else noData">
    <div class="bar-chart-container">
      <ng-container *ngIf="chartData.datasets.length; else noData">
        <div class="bar-chart-heading">
          <span *ngIf="tile && title" class="h3">{{ title }}</span>
          <div *ngIf="showLegend" class="bar-chart-legend">
            <div *ngFor="let item of legendItems" class="legend-item">
              <div class="legend-item-color" [ngStyle]="{ border: '8px solid ' + item.color }"></div>
              <span class="legend-item-text">{{ item.text }}</span>
            </div>
          </div>
        </div>

        <canvas #chart id="dashboard-main-chart-ctx"></canvas>
      </ng-container>
    </div>
    <app-dashboard-footer
      *ngIf="!tile"
      [hasData]="chartData.datasets.length"
      [currency]="dashboardState.config.config.currency_symbol"
    >
    </app-dashboard-footer>
  </ng-container>
  <ng-template #noData>
    <div
      *ngIf="!dashboardState.report.errorMessage"
      class="no-chart-data d-flex h-100 mb-3 mt-3 justify-content-center align-items-center"
      data-category="figures"
    >
      <div>
        <figure class="figure">
          <ng-container *ngIf="tile; else BigKaliuk">
            <svg class="kaliuk kaliuk-middle">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
          </ng-container>
          <ng-template #BigKaliuk>
            <svg class="kaliuk kaliuk-big">
              <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
            </svg>
          </ng-template>
          <figcaption class="figure-caption">
            <h4>{{ tile ? dashboardNoDataForDefaultPeriodString : dashboardNoDataForPeriodString }}</h4>
          </figcaption>
        </figure>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="isLoading$ | async">
  <spinner></spinner>
</ng-container>
